<template>
  <div class="container" v-if="!appLoaded">
    <div class="row min-vh-100 align-items-center">
      <div class="col-6 offset-3 col-lg-2 offset-lg-5">
        <img
          alt="Numbers of Success"
          class="w-100"
          src="./assets/img/nos.png"
        />
        <Spinner centered class="mt-5" />
      </div>
    </div>
  </div>
  <div class="container" v-else-if="initError">
    <div class="row min-vh-100 align-items-center">
      <div class="col-12 col-lg-6 offset-lg-3">
        <div class="alert alert-danger">
          <p>
            {{ initErrorMessage }}
          </p>
          <button
            class="btn btn-secondary"
            @click.prevent="logout"
            type="button"
          >
            {{ $t("logout") }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex flex-column min-vh-100" v-else>
    <TheHeader />
    <main class="container py-5">
      <router-view />
    </main>
    <TheFooter />
  </div>
</template>

<script>
import TheHeader from "./components/TheHeader";
import TheFooter from "./components/TheFooter";
import { mapGetters } from "vuex";
import Spinner from "./components/Spinner";
export default {
  components: { Spinner, TheFooter, TheHeader },
  computed: {
    ...mapGetters({
      appLoaded: "getAppLoadedState",
      initError: "getInitError",
    }),
    initErrorMessage() {
      return this.globalErrorText(this.initError);
    },
  },
  methods: {
    async logout() {
      await this.authLogout();
      await this.$router.push({ name: "account.login" });
      await this.$store.commit("SET_INIT_ERROR", null);
    },
  },
};
</script>

<style lang="scss"></style>
